import type { DataNode } from 'ant-design-vue/es/tree'
//筛选组织树
export function flattenOrganizationTree(
  tree: DataNode[],
  criteria: {
    name?: string
    code?: string
  } = {}
): DataNode[] {
  const result: DataNode[] = []

  function traverse(node: DataNode) {
    // 检查当前节点是否匹配
    let matches = true

    if (criteria.name) {
      const nameMatches = node?.title?.indexOf(criteria.name) !== -1

      matches = matches && nameMatches
    }

    if (criteria.code) {
      const mnemonicMatches = node?.code?.indexOf(criteria?.code) !== -1
      matches = matches && mnemonicMatches
    }

    if (matches) {
      result.push(node)
    }

    // 递归处理子节点
    if (node.children) {
      node.children.forEach((child: any) => traverse(child))
    }
  }

  tree.forEach((node) => traverse(node))
  return result
}
